import { render, staticRenderFns } from "./CreateSalesperson.vue?vue&type=template&id=3404733a"
import script from "./CreateSalesperson.vue?vue&type=script&lang=js"
export * from "./CreateSalesperson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports